export default `
  #graphql
  mutation amSocialLoginLinkAccount($type: String!) {
    amSocialLoginLinkAccount(type: $type) {
      isSuccess
      message
    }
  }
`;
